/**
 * Created by sange on 13/09/2017.
 */

export enum DialogType {
  Create = 0,
  Edit = 1,
}



// WEBPACK FOOTER //
// ./src/app/shared/dialog/dialog-type.ts